import React, { useEffect, useRef, useState } from "react";
import { UPPER_JAW, LOWER_JAW } from "./IPRInfo/data";
import Aligners from "./IPRInfo/IPRAligners";
import Tooth from "./IPRInfo/Tooth/Tooth";

const IPR = ({ upperAligners, chartValue, lowerAligners, hideTeethParam }) => {
  const [upperStructure, setUpperStructure] = useState(UPPER_JAW);
  const [lowerStructure, setLowerStructure] = useState(LOWER_JAW);
  
  return (
    <div>
      <div className="ipr-detail-container">
        <div className="teethChart-container">
          {/* {hideTeethParam !== "upper" && ( */}
            <Aligners alignersObj={upperAligners} alignerType="upper" />
          {/* )} */}

          <div className="teethRow-container">
            <div className="teethRow-bgOne" />
            {/* <div ref={targetDivRef}></div> */}
            <div className="teethRow-one ipr-row" >
      
              {hideTeethParam !== "upper" && (
                <>
                  {upperStructure.map(tooth => (
                      <Tooth
                       key={tooth.id}
                        type="upper"
                        tooth={tooth}
                        chartValue={chartValue}
                      />
         
                  ))}
                </>
              )}
              {!hideTeethParam?.length && (
                <div className="tooth-sides">
                  <h2>Right</h2>
                  <h2>Left</h2>
                </div>
              )}

              {hideTeethParam !== "lower" && (
                <>
                  {lowerStructure.map(tooth => (
                      <Tooth
                        type="lower"
                        tooth={tooth}
                        key={tooth.id}
                        chartValue={chartValue}
                      />
           
                  ))}
                </>
              )}
            </div>
              <div className="teethRow-bgTwo"></div>
          </div>
          {/* {hideTeethParam !== "lower" && ( */}
            <Aligners alignersObj={lowerAligners} alignerType="lower" />
          {/* )} */}
        </div>
      </div>
    </div>
  );
};

export default IPR;
